import { IQueryMediator } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { ScheduledPollDatastore } from './datastore/scheduled_poll_datastore';
import { PollCapabilityConfiguration } from './poll_configuration';
import { CheckScheduledPollsServant } from './servants/check_scheduled_poll_servant';

export function PollRoutes($stateProvider: ng.ui.IStateProvider) {
  const getScheduledPoll = (id: number) => {
    return {
      id,
      poll_id: id,
      rank: 0,
      mandatory: true,
      isIntakeOrFirstTerm: true
    };
  };

  const INTAKE_POLL_ROUTE_CONFIG = {
    url: '/intake-poll/',
    templateUrl: 'capability-ng-poll/src/views/poll/poll.html',
    controllerAs: '$ctrl',
    controller: 'PollController',
    data: {
      viewTitle: 'Intake Survey',
      hasMainMenu: false,
      ignoredInHistory: true,
      isIntakeUpdateMode: true
    },
    resolve: {
      poll: (
        $state: ng.ui.IStateService,
        ngPollCapabilityConfiguration: PollCapabilityConfiguration,
        ngScheduledPollDatastore: ScheduledPollDatastore,
        QueryMediator: IQueryMediator
      ) => {
        if (ngPollCapabilityConfiguration.config.hasIntakePoll) {
          const intakeOrTermID = _4.parseInt(ngPollCapabilityConfiguration.config.intakeOrFirstTermID);
          return QueryMediator.runQueries(
            ngScheduledPollDatastore.write({
              scheduledpoll: [getScheduledPoll(intakeOrTermID)]
            })
          );
        } else {
          return $state.go(ngPollCapabilityConfiguration.config.defaultRoute);
        }
      }
    }
  };

  const FIRSTTERM_POLL_ROUTE_CONFIG = {
    url: '/first-term-poll/',
    templateUrl: 'capability-ng-poll/src/views/poll/poll.html',
    controllerAs: '$ctrl',
    controller: 'PollController',
    data: {
      viewTitle: 'Intake Survey',
      hasMainMenu: false,
      ignoredInHistory: true,
      isIntakeUpdateMode: true
    },
    resolve: {
      poll: (
        $state: ng.ui.IStateService,
        ngPollCapabilityConfiguration: PollCapabilityConfiguration,
        ngScheduledPollDatastore: ScheduledPollDatastore,
        QueryMediator: IQueryMediator
      ) => {
        if (ngPollCapabilityConfiguration.config.hasFirstTerm) {
          const intakeOrTermID = _4.parseInt(ngPollCapabilityConfiguration.config.intakeOrFirstTermID);
          return QueryMediator.runQueries(
            ngScheduledPollDatastore.write({
              scheduledpoll: [getScheduledPoll(intakeOrTermID)]
            })
          );
        } else {
          return $state.go(ngPollCapabilityConfiguration.config.defaultRoute);
        }
      }
    }
  };

  $stateProvider
    .state('poll', {
      url: '/poll/',
      templateUrl: 'capability-ng-poll/src/views/poll/poll.html',
      data: {
        viewTitle: 'We Have Some Questions',
        hasMainMenu: false,
        ignoredInHistory: true
      },
      controller: 'PollController',
      controllerAs: '$ctrl',
      resolve: {
        _checkPoll: (
          ngCheckScheduledPollsServant: CheckScheduledPollsServant,
          $state: ng.ui.IStateService,
          ngPollCapabilityConfiguration: PollCapabilityConfiguration,
          accountModel: AccountModel
        ) => {
          if (ngPollCapabilityConfiguration.config.isMobile) {
            return true;
          }

          if (!accountModel.isLoggedIn()) {
            $state.go('startup');
          }

          if (ngCheckScheduledPollsServant.hasScheduledPolls()) {
            return true;
          }

          return ngCheckScheduledPollsServant.load().then(() => {
            if (!ngCheckScheduledPollsServant.hasScheduledPolls()) {
              $state.go(ngPollCapabilityConfiguration.config.defaultRoute);
            }
          });
        }
      }
    })
    .state('intake-poll', INTAKE_POLL_ROUTE_CONFIG)
    .state('first-term-poll', FIRSTTERM_POLL_ROUTE_CONFIG)
    .state('my.intake-poll', { ...INTAKE_POLL_ROUTE_CONFIG, url: 'intake-poll/' })
    .state('my.first-term-poll', { ...FIRSTTERM_POLL_ROUTE_CONFIG, url: 'first-term-poll/' });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/poll_routes.ts